module.exports = __webpack_public_path__ + "img/banner_left.a4da4154.png";